import React from 'react';

/**
 * A1.2 (Ops Console PRD 2026-08-21): the ONE way an absent field renders — an em-dash whose tooltip says why, never
 * a 0 and never a blank. Shared by OpsConsole.tsx and OpsAlertsPanel.tsx so the two cannot drift.
 */
export const Absent = ({ why = 'No source for this field' }: { why?: string }) => (
  <span className="text-muted-foreground select-none" title={why} aria-label={`absent: ${why}`}>—</span>
);
